import { render, staticRenderFns } from "./ProjectList.vue?vue&type=template&id=4787cf8d"
import script from "./ProjectList.vue?vue&type=script&lang=ts"
export * from "./ProjectList.vue?vue&type=script&lang=ts"
import style0 from "./ProjectList.vue?vue&type=style&index=0&id=4787cf8d&lang=scss"


/* normalize component */
import normalizer from "!../../.yarn/__virtual__/vue-loader-virtual-bcca2229bc/0/cache/vue-loader-npm-15.11.1-829412283a-509a816d45.zip/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/.yarn/cache/vue-hot-reload-api-npm-2.3.4-549ae26337-9befc0b3d6.zip/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4787cf8d')) {
      api.createRecord('4787cf8d', component.options)
    } else {
      api.reload('4787cf8d', component.options)
    }
    module.hot.accept("./ProjectList.vue?vue&type=template&id=4787cf8d", function () {
      api.rerender('4787cf8d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ProjectList.vue"
export default component.exports